import { useMutation } from '@apollo/client';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { gql } from '__generated__';
import { FC, useState } from 'react';

import Button from 'components/Button';
import { FormInput, FormPanel } from 'components/FormPanel';

const CREATE_DEPARTMENT_MUTATION = gql(`
  mutation CreateDepartment($name: String!, $shortName: String!, $logo: Upload) {
    createDepartment(name: $name, shortName: $shortName, logo: $logo) {
      id
      name
      shortName
      logo
      status
      updatedAt
      createdAt
    }
  }
`);

const CreateDepartmentDialogButton: FC = () => {
  const [showDialog, toggleDialog] = useState(false);

  const [createDepartment, { loading, error }] = useMutation(CREATE_DEPARTMENT_MUTATION, {
    update(cache, { data }) {
      if (!data) return;
      cache.modify({
        fields: {
          departments(existingDepartmentsRef) {
            const newPostNodeRef = cache.writeFragment({
              data: data.createDepartment,
              fragment: gql(`
                fragment NewDepartment on DepartmentType {
                  id
                  name
                  shortName
                  status
                  updatedAt
                  createdAt
                }
              `),
            });
            const updatedDepartmentsRef = { ...existingDepartmentsRef };
            updatedDepartmentsRef.nodes = [newPostNodeRef, ...updatedDepartmentsRef.nodes];
            return updatedDepartmentsRef;
          },
        },
      });
    },
  });

  return (
    <>
      <Button onClick={() => toggleDialog(true)}>Add Department</Button>
      <Dialog open={showDialog} onClose={() => toggleDialog(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Add a Department</DialogTitle>
        <DialogContent sx={{ minHeight: '50vh' }}>
          <FormPanel
            loading={loading}
            error={error}
            onCancel={() => toggleDialog(false)}
            onSubmit={data => {
              createDepartment({
                variables: {
                  name: data.name,
                  shortName: data.shortName,
                  logo: data.logo ? data.logo : undefined,
                },
              }).then(() => toggleDialog(false));
            }}
          >
            <FormInput
              fullWidth
              type="string"
              fieldName="name"
              label="Name"
              defaultValue=""
              validators={{
                required: true,
              }}
            />
            <FormInput
              fullWidth
              type="string"
              fieldName="shortName"
              label="Short Name"
              defaultValue=""
              validators={{
                required: true,
              }}
            />
            <FormInput
              fieldName="logo"
              type="upload"
              fullWidth
              defaultValue={''}
              label="Department Logo"
              validators={{
                required: true,
              }}
            />
          </FormPanel>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CreateDepartmentDialogButton;
